import { DEVICE_ID_HEADER, TERMINAL_ID_HEADER } from '@iws/backoffice-api'

import { configService } from '@/services/ConfigService'

/** Headers every backoffice request carries; the sync stream uses them too (it calls fetch, not axios). */
export const apiHeaders = (): Record<string, string> => {
  const { bearerToken, clientHost, systemUid, deviceUid, terminalId } = configService.getConfig().apiConfig
  const headers: Record<string, string> = {}
  if (bearerToken) headers.Authorization = `Bearer ${bearerToken}`
  if (clientHost) headers['X-Client-Host'] = clientHost
  if (systemUid) headers['X-System-Uid'] = systemUid
  if (deviceUid) headers[DEVICE_ID_HEADER] = deviceUid
  if (terminalId) headers[TERMINAL_ID_HEADER] = terminalId
  return headers
}
